export default "__VITE_ASSET__RL0FtVhu__"